/**
 * Returns capitalized string
 */
export const capitalize = (word: string): string => (
    word ? `${word.charAt(0).toUpperCase()}${word.slice(1).toLowerCase()}` : ''
)
